import classNames from "classnames";
import React, { ReactElement } from "react";

interface Props {
  isFullscreen: boolean;
  currentSubtitle: string;
}

export const PlayerSubtitles = React.memo(function PlayerSubtitles(props: Props): ReactElement {
  return (
    <div
      className={classNames({
        VideoScreen__subtitles: true,
        VideoScreen__subtitlesFullscreen: props.isFullscreen,
      })}
    >
      <div className="VideoScreen__subtitlesContainer">
        <div className="VideoScreen__subtitlesText">{props.currentSubtitle}</div>
      </div>
    </div>
  );
});
